import React, { useState } from 'react'
import Reveal, { Fade } from 'react-awesome-reveal'
import { fadeInRightShorter } from '../utils/keyframes'

const ContentEnSm = () => {
    return (
        <>
            <h5 className='fw-bold'>We aspire a healthier community</h5>
            <p className='small'>
                Fefine Napkins is a high-quality product of 'Greenviron manufacturers', which was launched with the noble aim of being made only with natural and medicinal ingredients and being easily foldable without harming the environment after use.
                Only 36% of the 336 million women who experience natural events in our country use sanitary napkins. Among these, 77% in urban areas and 23% in rural areas use napkins. Research statistics show that 121 million women use disposable pads, generating about 9000 tons of used napkins as waste per year, posing a great threat to the environment.
            </p>
            <p className='small'>
                Women who continue to use sanitary napkins made with unhygienic chemicals and harmful plastics are prone to serious diseases, including uterine-related anemia and cancer. During these stages, they suffer from extreme fatigue, distraction, lack of interest in anything, impatience, and irritable mood, losing their ability.
            </p>
        </>
    )
}

const ContentEnLg = () => {
    return (
        <>
            <h5 className='fw-bold'>We aspire a healthier community</h5>
            <p className='small'>
                Fefine Napkins is a high-quality product of 'Greenviron manufacturers', which was launched with the noble aim of being made only with natural and medicinal ingredients and being easily foldable without harming the environment after use.
                Only 36% of the 336 million women who experience natural events in our country use sanitary napkins. Among these, 77% in urban areas and 23% in rural areas use napkins. Research statistics show that 121 million women use disposable pads, generating about 9000 tons of used napkins as waste per year, posing a great threat to the environment.
            </p>
            <p className='small'>
                Women who continue to use sanitary napkins made with unhygienic chemicals and harmful plastics are prone to serious diseases, including uterine-related anemia and cancer. During these stages, they suffer from extreme fatigue, distraction, lack of interest in anything, impatience, and irritable mood, losing their ability.
                Fefine Sanitary Napkin is preferred by women entrepreneurs, large industrial institutes, educational institutions, hospitals, commercial service organizations, the military, banks, government, public and private organizations, high officials, and high officials.
            </p>
            <p className='small'>
                Fefine Sanitary Napkins are made of all-natural materials, as women's full focus is on their work, helping them emerge as women of achievement and create a new history.
            </p>
            <p className='small'>
                Fefine Sanitary Napkin is manufactured in the most hygienic way
                i) Purified cotton and ii) With soothing herbs like aloe vera, neem and camel grass.
            </p>
        </>
    )
}

const ContentTaSm = () => {
    return (
        <>
            <h5 className='fw-bold'>ஆரோக்கியமான சமூகத்தை நாங்கள் விரும்புகிறோம்</h5>
            <p className='small'>
                இயற்க்கையான மற்றும் மருத்துவ குணமிக்க பொருட்களை மட்டுமே கொண்டு தயாரிக்கப்பட வேண்டும். பயன்பாட்டுக்கு பின் சுற்றுச் சூழலுக்கு எவ்வித பாதிப்பும்  இன்றி
                எளிதில் மட்கும் திறன் கொண்டதாக அது இருத்தல் வேண்டும், என்ற உன்னத நோக்கத்துடன் தொடங்கப்பட்டது தான் 'Greenviron manfacturers' இதன் உயர்தர தயாரிப்பு Fefine Napkins.
                நம் நாட்டில் இயற்க்கை நிகழ்வுகளுக்குட்பட்ட சுமார் 336 மில்லயன் பெண்களில் 36% மட்டுமே நாப்கின்களை முழுமையாக
                பயன்படுத்துகிறார்கள். இவற்றில் பெருநகரங்களில் 77% ஊரகப் பகுதிகளில் 23% விழுக்காடு அளவிற்க்கும் நாப்கின்கள் பயன்பாடு உள்ளது. 121 மில்லியன் பெண்கள் disposable pads பயன்படுத்துவதாகவும் வருடத்திற்கு சுமார் 9000 டன் பயன்படுத்தப்பட்ட நாப்கின்கள் கழிவுகளாக உருவாகி மக்கா தன்மையுடன் சுற்றுச் சூழலுக்கு மிகுந்த அச்சுறுத்தலை எற்படுத்தி வருவதாக ஆய்வு புள்ளி விவரங்கள் தெரிவிக்கிறது
            </p>
            <p className='small'>
                சுகாதாரமற்ற இயற்க்கைக்கு மாறான வேதிப்பொருள் மற்றும் தீங்கு விளைவிக்கும் பிலாஸ்டிக்கை கொண்டு தயாரிக்கப்படும் நாப்கின்களை தொடர்ந்து பயன்படுத்தி வரும் பெண்கள் கருப்பை சார்ந்த - இரத்த சோகை மற்றும் புற்றுநோய் உள்ளிட்ட கடுமையான நோய்களுக்கு உட்படுகிறார்கள்.மேலும் அக்கால கட்டங்களில், மிகுந்த சோர்வு, கவனச் சிதறல், எதிலும் ஆர்வமற்ற நிலை, பொறுமை இழத்தல், மற்றும் எரிச்சலூட்டும் மனநிலைக்கு ஆட்படுவதால் சிறந்த செயலாக்க திறனை அவர்கள் இழந்து விடுகிறார்கள்
            </p>
        </>
    )
}


const ContentTaLg = () => {
    return (
        <>
            <h5 className='fw-bold'>ஆரோக்கியமான சமூகத்தை நாங்கள் விரும்புகிறோம்</h5>
            <p className='small'>
                இயற்க்கையான மற்றும் மருத்துவ குணமிக்க பொருட்களை மட்டுமே கொண்டு தயாரிக்கப்பட வேண்டும். பயன்பாட்டுக்கு பின் சுற்றுச் சூழலுக்கு எவ்வித பாதிப்பும்  இன்றி
                எளிதில் மட்கும் திறன் கொண்டதாக அது இருத்தல் வேண்டும், என்ற உன்னத நோக்கத்துடன் தொடங்கப்பட்டது தான் 'Greenviron manfacturers' இதன் உயர்தர தயாரிப்பு Fefine Napkins.
                நம் நாட்டில் இயற்க்கை நிகழ்வுகளுக்குட்பட்ட சுமார் 336 மில்லயன் பெண்களில் 36% மட்டுமே நாப்கின்களை முழுமையாக
                பயன்படுத்துகிறார்கள். இவற்றில் பெருநகரங்களில் 77% ஊரகப் பகுதிகளில் 23% விழுக்காடு அளவிற்க்கும் நாப்கின்கள் பயன்பாடு உள்ளது. 121 மில்லியன் பெண்கள் disposable pads பயன்படுத்துவதாகவும் வருடத்திற்கு சுமார் 9000 டன் பயன்படுத்தப்பட்ட நாப்கின்கள் கழிவுகளாக உருவாகி மக்கா தன்மையுடன் சுற்றுச் சூழலுக்கு மிகுந்த அச்சுறுத்தலை எற்படுத்தி வருவதாக ஆய்வு புள்ளி விவரங்கள் தெரிவிக்கிறது
            </p>
            <p className='small'>
                சுகாதாரமற்ற இயற்க்கைக்கு மாறான வேதிப்பொருள் மற்றும் தீங்கு விளைவிக்கும் பிலாஸ்டிக்கை கொண்டு தயாரிக்கப்படும் நாப்கின்களை தொடர்ந்து பயன்படுத்தி வரும் பெண்கள் கருப்பை சார்ந்த - இரத்த சோகை மற்றும் புற்றுநோய் உள்ளிட்ட கடுமையான நோய்களுக்கு உட்படுகிறார்கள்.மேலும் அக்கால கட்டங்களில், மிகுந்த சோர்வு, கவனச் சிதறல், எதிலும் ஆர்வமற்ற நிலை, பொறுமை இழத்தல், மற்றும் எரிச்சலூட்டும் மனநிலைக்கு ஆட்படுவதால் சிறந்த செயலாக்க திறனை அவர்கள் இழந்து விடுகிறார்கள். பெண்கள் தொழில் முனைவோர்களாகவும், பெரும் தொழிற் கூடங்கள்கல்வி நிறுவனங்கள் மருத்துவ மனைகள் வர்த்தக சேவை நிறுவனங்கள் இராணுவம், வங்கிகள் அரசு அரசுசார் மற்றும் தனியார் நிறுவனங்களில் பணிபுரிபவர்களாகவும், உயர் அலுவலர்களாகவும்  திகழ்கின்றனர் அவர்கள் நல்ல உடல் நலத்துடன் எல்லா தருணங்களிலும் தன்னம்பிக்கை அளித்து தேவையற்ற கவனச்சிதறலை தடுத்து மகிழ்ச்சியான மனநிலைக்கு  ‘Fefine Sanitary Napkin' பொறுப்பேற்கிறது.
            </p>
            <p className='small'>
                பெண்களின் முழு கவனமும் அவர்கள் பணிகளில் மட்டுமே இருப்பதால் அவர்கள் சாதனைப் பெண்களாக உருவெடுத்து புதிய சரித்திரம்படைத்திட துணைபுரிகிறது Fefine Sanitary Napkins
            </p>
            <p className='small'>
                i) தூய்மை படுத்திய பஞ்சினை கொண்டும் ii) இவற்றுடன் சோற்றுக் கற்றாழை, வேப்பிலை மற்றும் வெட்டிவேர் போன்ற மடுத்துவ குணமிக்க மூலிகைகளை கொண்டும் இருவகைகளில் Fefine Sanitary Napkin மிக சுகாதாரமான முறையில் தயாரிக்கப்படுகிறது
            </p>
        </>
    )
}

const AboutUs = () => {
    const [isMore, setMore] = useState(false);
    const [lang, setLang] = useState(true); // true = EN
    return (
        <section id='about-us'>
            <div className='container'>
                <div className="row">
                    <div className="col-lg-6">
                        <Fade duration={2000} delay={200}>
                            <div className="about-image-wrapper">
                                <img src={require('../assets/images/about.png')} className='mb-3 w-100' />
                            </div>
                        </Fade>
                    </div>
                    <div className="col-lg-6 ps-lg-4 text-justify">
                        <Reveal keyframes={fadeInRightShorter} delay={200} duration={1000}>
                            {
                                lang ? (isMore ? <ContentEnLg /> : <ContentEnSm />) : (isMore ? <ContentTaLg /> : <ContentTaSm />)
                            }
                            <div className="d-flex align-items-center">
                                <button onClick={() => setMore(!isMore)} className='btn btn-primary'>
                                    {isMore ? 'Show less' : 'Read more'}
                                </button>
                                <button className='btn' onClick={() => setLang(!lang)}><img src={require('../assets/images/translate.png')} /></button>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutUs